/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} License_Renew_ButtonInputs */



/**
* | output |
* | --- |
* | "Renew updates" |
*
* @param {License_Renew_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const license_renew_button = /** @type {((inputs?: License_Renew_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<License_Renew_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Renouveler les mises à jour")
	if (locale === "de") return /** @type {LocalizedString} */ ("Updates verlängern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rinnova aggiornamenti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Продлить обновления")
	if (locale === "es") return /** @type {LocalizedString} */ ("Renovar actualizaciones")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("续订更新")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アップデートを延長")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अपडेट नवीनीकृत करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Renovar atualizações")
	return /** @type {LocalizedString} */ ("Renew updates")
});